import React from 'react';
import '../../../styles/components/_ox-input-group.scss';

const OxInputGroup = ({ children }) => (
  <div className="ox-input-group">{children}</div>
);

export default OxInputGroup;
